import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LangProvider, useLang } from "./context/LangContext";
import { StoreProvider } from "./context/StoreContext";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import StoreLayout from "./components/store/StoreLayout";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductPage from "./pages/ProductPage";
import Checkout from "./pages/Checkout";
import OrderConfirmation from "./pages/OrderConfirmation";
import PayPage from "./pages/PayPage";
import TrackOrder from "./pages/TrackOrder";
import Account from "./pages/Account";
import AuthCallback from "./pages/AuthCallback";
import Wishlist from "./pages/Wishlist";
import InfoPage, { FaqPage } from "./pages/InfoPage";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import Products from "./pages/admin/Products";
import ProductForm from "./pages/admin/ProductForm";
import Categories from "./pages/admin/Categories";
import Coupons from "./pages/admin/Coupons";
import Orders from "./pages/admin/Orders";
import OrderDetail from "./pages/admin/OrderDetail";
import Customers from "./pages/admin/Customers";
import Shipping from "./pages/admin/Shipping";
import Content from "./pages/admin/Content";
import Settings from "./pages/admin/Settings";
import Staff from "./pages/admin/Staff";
import Finance from "./pages/admin/Finance";
import Calculator from "./pages/admin/Calculator";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<StoreLayout />}>
        <Route index element={<Home />} />
        <Route path="shop/:collection" element={<Shop />} />
        <Route path="product/:slug" element={<ProductPage />} />
        <Route path="checkout" element={<Checkout />} />
        <Route path="order/:number" element={<OrderConfirmation />} />
        <Route path="pay/:number" element={<PayPage />} />
        <Route path="track" element={<TrackOrder />} />
        <Route path="account" element={<Account />} />
        <Route path="wishlist" element={<Wishlist />} />
        <Route path="faq" element={<FaqPage />} />
        <Route path="page/:slug" element={<InfoPage />} />
        <Route path="*" element={<Shop />} />
      </Route>
      <Route path="admin/login" element={<AdminLogin />} />
      <Route path="admin" element={<AdminLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="products" element={<Products />} />
        <Route path="products/:id" element={<ProductForm />} />
        <Route path="categories" element={<Categories />} />
        <Route path="coupons" element={<Coupons />} />
        <Route path="orders" element={<Orders />} />
        <Route path="orders/:number" element={<OrderDetail />} />
        <Route path="customers" element={<Customers />} />
        <Route path="shipping" element={<Shipping />} />
        <Route path="content" element={<Content />} />
        <Route path="settings" element={<Settings />} />
        <Route path="staff" element={<Staff />} />
        <Route path="finance" element={<Finance />} />
        <Route path="calculator" element={<Calculator />} />
      </Route>
    </Routes>
  );
}

const ToastHost = () => {
  const { isRTL } = useLang();
  return <Toaster position={isRTL ? "bottom-left" : "bottom-right"} dir={isRTL ? "rtl" : "ltr"} toastOptions={{ style: { borderRadius: 0, fontFamily: "var(--font-body)" } }} />;
};

export default function App() {
  return (
    <div className="App">
      <LangProvider>
        <StoreProvider>
          <AuthProvider>
            <CartProvider>
              <BrowserRouter>
                <AppRouter />
              </BrowserRouter>
              <ToastHost />
            </CartProvider>
          </AuthProvider>
        </StoreProvider>
      </LangProvider>
    </div>
  );
}
